import React, { useState, useEffect, ChangeEvent } from 'react'
import { FieldStyled, WrapLabelStyled, FormControlStyled, WrapIconStyled } from './styles'
import { Icon, Info, Label, SlimButton } from 'components'
import { formatBytes } from 'commons/utils/format'
import { truncateString } from 'commons/utils/string'
import { ChangeEventHandler } from 'react'
import { theme } from 'styles/theme/hav-theme'

export type DSUploadButtonType =
  | 'hav-master-field-input'
  | 'hav-text-field-input'
  | 'hav-search-field-input'

export type OnChangeUpload = ChangeEventHandler<HTMLInputElement>

export interface UploadButtonProps {
  name?: string
  id?: string
  accept?: string
  value: File
  label?: string
  disabled?: boolean
  info?: string
  onClear?: () => void
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  onChange: OnChangeUpload
  addorment?: boolean
  error?: string | null
  errorOutline?: boolean
  required?: boolean
  width?: number
  truncateName?: number
  rows?: number
  placeholder?: string
  onClick?: () => void
  padding?: string | number
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  name = undefined,
  id,
  value,
  accept = '',
  placeholder = '',
  label = '',
  info,
  onChange,
  truncateName = 30,
  onClear = () => {
    return
  },
  onClick = () => {
    return
  },
  required = false,
  disabled = false,
  width,
  errorOutline,
  padding
}) => {
  const [fileTitle, setFileTitle] = useState('')
  useEffect(() => {
    if (value?.name) {
      setFileTitle(value.name)
    } else {
      setFileTitle('')
    }
  }, [value])

  const handleOnchange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e) {
      onChange(e)
    }
  }

  const handleFile = () => {
    if (fileTitle) {
      return `${truncateString(fileTitle, truncateName)} (${formatBytes(value.size, 0)})`
    }
    return placeholder
  }

  return (
    <>
      {label && (
        <WrapLabelStyled hasInfo={info}>
          <Label id="LabelInputForm" htmlFor={name} required={required}>
            {label}
          </Label>
          {info && <Info>{info}</Info>}
        </WrapLabelStyled>
      )}
      <FormControlStyled {...(width && { width })}>
        <FieldStyled
          id="upload-container"
          padding={padding}
          errorOutline={errorOutline}
          disabled={disabled}
        >
          <input
            id={id}
            type="file"
            accept={accept}
            name={name}
            required={required}
            disabled={disabled}
            onChange={handleOnchange}
          />

          <WrapIconStyled
            justifyContent="space-between"
            disabled={disabled}
            onClick={disabled ? () => 0 : onClick}
          >
            <label htmlFor={id}>
              <WrapIconStyled justifyContent="center">
                <Icon icon="paper-clip" color={theme.colors.primary.main} size="15" />
                <span>{handleFile()}</span>
                {required && <span id="asterisk">*</span>}
              </WrapIconStyled>
            </label>
            {fileTitle && (
              <SlimButton
                variant="icon"
                onClick={onClear}
                icon={<Icon icon="trash" size="20" />}
              />
            )}
          </WrapIconStyled>
        </FieldStyled>
      </FormControlStyled>
    </>
  )
}
